import { useLocation, Navigate, Outlet } from "react-router-dom";
import { GlobalContext } from "./GlobalContext";
import { useContext } from "react";

type RequiredAuthProps = {
    allowedRoles?: string[];
};

const RequiredAuth = ({ allowedRoles }: RequiredAuthProps) => {
    const { state } = useContext(GlobalContext);
    const { auth } = state;
    const location = useLocation();

    if (!auth?.token) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (!allowedRoles || allowedRoles.length === 0) {
        return <Outlet />;
    }

    const userRoles: string[] = Array.isArray(auth?.user?.roles) ? auth.user.roles : [];
    const hasAllowedRole = userRoles.some((role) => allowedRoles.includes(role));

    if (!hasAllowedRole) {
        return <Navigate to="/account" replace />;
    }

    return (
        <Outlet />
    );
}

export default RequiredAuth;
